var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_CustomFormRecord_list_viewTitle"),
      backgroundClass: "transparent",
      widthClass: "max-1000",
      pad: "0",
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            !_vm.Data ? _c("noContent") : _vm._e(),
            _vm.Data
              ? _c("ApprovalTriger", {
                  attrs: {
                    "bg-color": _vm.Data.approval_bg_color,
                    "slide-color": _vm.Data.approval_tint_color,
                  },
                  on: {
                    triger: function ($event) {
                      return _vm.$toPage(
                        "/admin/custom-form-record/detail/" +
                          _vm.$route.params.params +
                          "/approval-detail/" +
                          _vm.$route.params.params
                      )
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "time",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getDateTime(
                                    _vm.Data.operate_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "status",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.Data.status_detail
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2072884572
                  ),
                })
              : _vm._e(),
            _vm.Data
              ? _c(
                  "Section",
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveApplication_form_swiftNumberLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: _vm.$t(
                                  "label_essweb_leaveApplication_form_swiftNumberLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                              model: {
                                value: _vm.Data.swift_number,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Data, "swift_number", $$v)
                                },
                                expression: "Data.swift_number",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveApplication_form_submitDateLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                value: _vm.$getDateTime(
                                  _vm.Data.submission_utc_datetime,
                                  "YYYY/MM/DD HH:mm"
                                ),
                                label: _vm.$t(
                                  "label_essweb_leaveApplication_form_submitDateLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveApplication_form_applicantLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-autocomplete", {
                              attrs: {
                                "single-line": "",
                                readonly: "",
                                items: _vm.users,
                                "append-icon": "",
                                "item-value": "uuid",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "no-data",
                                    fn: function () {
                                      return [_c("noContent")]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-chip",
                                          _vm._b(
                                            {
                                              attrs: {
                                                pill: "",
                                                "input-value": data.selected,
                                              },
                                            },
                                            "v-chip",
                                            data.attrs,
                                            false
                                          ),
                                          [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                left: "",
                                                src: data.item.staff_avatar,
                                                staff_name:
                                                  data.item.preferred_name,
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4123812085
                              ),
                              model: {
                                value: _vm.user,
                                callback: function ($$v) {
                                  _vm.user = $$v
                                },
                                expression: "user",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.Data &&
            _vm.Data["ess_common_application_type_custom_field_value"]
              ? _c(
                  "Section",
                  [
                    _vm.Data["ess_common_application_type_custom_field_value"]
                      .length > 1
                      ? _c(
                          "v-form",
                          { ref: "form", attrs: { "lazy-validation": "" } },
                          [
                            _c(
                              "v-row",
                              _vm._l(
                                _vm.Data[
                                  "ess_common_application_type_custom_field_value"
                                ],
                                function (item, index) {
                                  return _c("DynamicForm", {
                                    key: "formitem--" + index,
                                    attrs: {
                                      data: item,
                                      iSEdited: _vm.iSEdited,
                                    },
                                    on: {
                                      change: function (uuid, value, change) {
                                        item["_value"] = value
                                        item["is_changed"] = !change
                                      },
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "v-row",
                          _vm._l(
                            _vm.Data[
                              "ess_common_application_type_custom_field_value"
                            ],
                            function (item, index) {
                              return _c("DynamicForm", {
                                key: "formitem--" + index,
                                attrs: { data: item, iSEdited: _vm.iSEdited },
                                on: {
                                  change: function (uuid, value, change) {
                                    item["_value"] = value
                                    item["is_changed"] = !change
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { submitBtn: "" },
                  on: { submit: _vm.toSave, cancel: _vm.toBack },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }